import React, { useEffect, useState, useContext, useRef, useCallback } from "react";
import { Header } from "../../../components/Header";
import { Menu } from "../../../components/Menu";
import { MenuPage } from "../../../components/MenuPage";
import { StyledDefaultPage } from "../../../styled-components/StyledDefaultPage.style";
import { StyledProgramasFormPmePage } from "../../../styled-components/StyledProgramasFormPmePage.style";
import { StyledTablePmePrograma } from "../../../styled-components/StyledTablePmePrograma.style";
import { StyledTablePage } from "../../../styled-components/StyledTablePage.style";
import { StyledForm } from "../../../styled-components/StyledForm.style";
import { StldRow } from "../../../styled-components/StldRow.style";
import { StldColumn } from "../../../styled-components/StldColumn.style";

import api from '../../../services/api';
import { MobileContext } from "../../../contexts/MobileContext";
import "react-datepicker/dist/react-datepicker.css";
import DatePicker from 'react-datepicker';
import Swal from "sweetalert2";
import Flex from '@react-css/flex';
import { useParams } from "react-router-dom";
import { useHistory } from "react-router-dom";
import { Link } from "react-router-dom";

import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import { Multiselect } from 'multiselect-react-dropdown';
import { ToggleSwitch } from "../../../components/ToggleSwitch";
import { DynamicSelectPME } from "../../../components/DynamicSelectPME";
import { ModalCicloPme } from "../../../components/ModalCicloPme";
import { ModalRegrasMeritoPme } from "../../../components/ModalRegrasMeritoPme";
import { ModalPerfilPme } from "../../../components/ModalPerfilPme";
import { ModalProfissionalPme } from "../../../components/ModalProfissionalPme";
import { DynamicInputPME } from "../../../components/DynamicInputPME";
import { DynamicSelect } from "../../../components/DynamicSelect";
import { getEmpresas } from '../../../services/empresas';

import { StyledUploadTimeSheet } from "../../../styled-components/StyledUploadTimeSheet.style";
import { ModalImportPMEMultiplicadores } from "../../../components/ModalImportPMEMultiplicadores";

import _ from 'lodash';


const MemorizedDynamicInput = React.memo(DynamicInputPME)
const MemorizedDynamicInputAnexo = React.memo(DynamicInputPME)
const MemorizedDynamicInputPerfilPeritos = React.memo(DynamicInputPME)
const MemorizedDynamicInputPerfilDesigners = React.memo(DynamicInputPME)
const MemorizedDynamicInputPerfilAdministrativo = React.memo(DynamicInputPME)
const MemorizedDynamicInputHoraMediaFaturadaGlobal = React.memo(DynamicInputPME)
const MemorizedDynamicInputHoraMediaFaturadaUnidadeNegocio = React.memo(DynamicInputPME)
const MemorizedDynamicInputHoraFaturadaIndividual = React.memo(DynamicInputPME)
const MemorizedDynamicInputPercFranquia1Mes = React.memo(DynamicInputPME)
const MemorizedDynamicInputPercFranquia2Mes3Mes = React.memo(DynamicInputPME)
const MemorizedDynamicInputGatilhoMerito = React.memo(DynamicInputPME)
const MemorizedDynamicInputHMFGlobal = React.memo(DynamicInputPME)
const MemorizedDynamicInputHMFUnidadeNegocio = React.memo(DynamicInputPME)
const MemorizedDynamicInputHMFIndividual = React.memo(DynamicInputPME)
const MemorizedDynamicInputSuperHMFGlobal = React.memo(DynamicInputPME)
const MemorizedDynamicInputSuperHMFUnidadeNegocio = React.memo(DynamicInputPME)
const MemorizedDynamicInputSuperHMFIndividual = React.memo(DynamicInputPME)
const MemorizedDynamicInputAdmRHD = React.memo(DynamicInputPME)

const getUsuarios = async(values, currentPage, pageSize) => {
    let list = null;
    let params = `Status=true&ProfissionalExterno=false`;

    try {
        const response = await api.get(`Usuario/listPME?${params}`);
        list = response.data || [];
        return list;
    } catch (err) {
        console.error("API Error:", err);
        return [];
    }
}

export const PmeProgramasForm = () => {
    const isMobile = useContext(MobileContext);
    const isDesktop = !isMobile;
    const history = useHistory();
    const [isEdit, setIsEdit] = useState(false); 
    const [activeTab, setActiveTab] = useState(0);
    const { idPrograma } = useParams(); 
    
    const config = {
        headers: {
            'Content-Type': 'application/json',
            'Access-Control-Allow-Credentials': false
        }
    }

    const [formGerais, setFormGerais] = useState({
        nomePrograma: '',
        dataInicio: '',
        dataFim: '',
        anexoPath: '',
        idEmpresa: '',
        Ciclos: []
    });

    const [formPerfis, setFormPerfis] = useState({
        idPerfil: 0,
        perfilPeritos: '',
        perfilDesigners: '',
        perfilAdministrativo: ''
    });

    const [formGatilhos, setFormGatilhos] = useState({
        idGatilho: 0,
        horaMediaFaturadaGlobal: 0.00,
        horaMediaFaturadaUnidadeNegocio: 0.00,
        horaFaturadaIndividual: 0.00
    });

    const [formMetas, setFormMetas] = useState({
        idMeta: 0,
        HMFGlobal: '',
        HMFUnidadeNegocio: '',
        HMFIndividual: '',
        superHMFGlobal: '',
        superHMFUnidadeNegocio: '',
        superHMFIndividual: '',
        admRHD: '',
    }); 

    const [formRegras, setFormRegras] = useState({
        idRegra: 0,
        // aplicarPercTempo: false,
        // aplicarPercFranquia: false,
        aplicarPercProfissionalDesigner: false,
        percFranquia1Mes: 0.00,
        percFranquia2Mes3Mes: 0.00,
        gatilhoMerito: 0.00,
    });

    const [idProgramaParam, setIdProgramaParam] =  useState(0);
    const nomeProgramaRef = useRef(null);
    const anexoUrl = useRef(null);
    const multiselectRef = useRef(null);

    const inputFile = useRef(null);
    const inputFileRefs = useRef({});
    let [file, setFile] = useState([]);
    let [fileName, setFileName] = useState(null);
    const [uploadedData, setUploadedData] = useState({});
    const [uploadedFileNames, setUploadedFileNames] = useState({});
    const perfilPeritosRef = useRef(null);
    const perfilDesignersRef = useRef(null);
    const perfilAdministrativoRef = useRef(null);

    const [perfis, setPerfis] = useState();
    const [idPerfil, setIdPerfil] = useState(null);
    const [perfisList, setPerfisList] = useState([]);
    const [returnedList, setReturnedList] = useState({});
    const [perfisMultiplicadoresList, setPerfisMultiplicadoresList] = useState([]);
    const [modalPerfilPme, setModalPerfilPme] = useState(false);
    const [modalRegrasMeritoPme, setModalRegrasMeritoPme] = useState(false);
    const [modalPerfilTabelaPme, setModalPerfilTabelaPme] = useState(false);
    const [modalPerfilTabela, setModalPerfilTabela] = useState({
        idPerfil: '',
        idPrograma: ''
    });    

    const horaMediaFaturadaGlobalRef = useRef(formGatilhos.horaMediaFaturadaGlobal);
    const horaMediaFaturadaUnidadeNegocioRef = useRef(formGatilhos.horaMediaFaturadaUnidadeNegocio);
    const horaFaturadaIndividualRef = useRef(formGatilhos.horaFaturadaIndividual);

    const HMFGlobalRef = useRef(null);
    const HMFUnidadeNegocioRef = useRef(null);
    const HMFIndividualRef = useRef(null);
    const superHMFGlobalRef = useRef(null);
    const superHMFUnidadeNegocioRef = useRef(null);
    const superHMFIndividualRef = useRef(null);
    const admRHDRef = useRef(null);

    const aplicarPercTempoRef = useRef(null);
    const aplicarPercFranquiaRef = useRef(null);
    const aplicarPercProfissionalDesignerRef = useRef(null);
    const percFranquia1MesRef = useRef(null);
    const percFranquia2Mes3MesRef = useRef(null);
    const gatilhoMeritoRef = useRef(null);

    const [ciclosTiposList, setCiclosTiposList] = useState([]);
    const [idCiclos, setIdCiclos] = useState([]);
    const [ciclosList, setCiclosList] = useState([]);

    const [profissional, setProfissional] = useState(null);
    const [idProfissional, setIdProfissional] = useState(null);
    const [profissionaisList, setProfissionaisList] = useState([]);
    const [profissionais, setProfissionais] = useState([]);
    const [modalProfisionalPme, setModalProfissionalPme] = useState(false);
    const [modalAddProfissional, setModalAddProfissional] = useState(false);

    const [listaUsuariosData, setListaUsuariosData] = useState(null);
    const [listaProfissionaisData, setListaProfissionaisData] = useState([]);
    const [selectedUsers, setSelectedUsers] = useState([]);
    const [pageSize, setPageSize] = useState(10);
    const [currentPage, setCurrentPage] = useState(0);
    const [usuarioNome, setUsuarioNome] = useState(null);    

    const [modalCicloPme, setModalCicloPme] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    const [selectedCiclos, setSelectedCiclos] = useState(null);

    const [dataPrograma, setDataPrograma] = useState([]);

    const [filtroArea, setFiltroArea] = useState("");
    const [filtroNome, setFiltroNome] = useState("");

    const [areas, setAreas] = useState([]);
    const [areasGestoras, setAreasGestoras] = useState([]);
    const [listMeritos, setMeritos] = useState([]);
    const [meritoEdit, setMeritoEdit] = useState(false);
    const [idRegraMerito, setIdRegraMerito] = useState(-1);
    const areasExcluidas = ["C.D.F", "M.E.Q", "Business interruption", "CRT Group"];

    const [empresaList, setEmpresaList] = useState([]);
    const [empresaSelecionada, setEmpresaSelecionada] = useState(null);
    const [empresaId, setEmpresaId] = useState(null);

    const convertDecimal = (value) => {
        const decimalValue = parseFloat(value);
        return decimalValue;
    }

    const usuariosFiltrados = !isEdit ? listaUsuariosData?.data : listaUsuariosData?.data?.filter((usuario) =>            
        (usuario.nome?.toLowerCase() || "").includes(filtroNome?.toLowerCase() || "") &&
        (usuario.nomeArea?.toLowerCase() || "").includes(filtroArea?.toLowerCase() || "")           
    );

    // ABA Dados Gerais
    const handleNomeProgramaChange = useCallback((currentValue) => {
        setFormGerais((prev) => ({ ...prev, nomePrograma: currentValue }));
    }, []);

    const handleStartDateChange = (date) => setFormGerais((prev) => ({ ...prev, dataInicio: date }));
    const handleEndDateChange = (date) => setFormGerais((prev) => ({ ...prev, dataFim: date }));
    const handleAnexoPathChange = (currentValue) => {
        setFormGerais((prev) => ({ ...prev, anexoPath: currentValue }));
    };

    const getCiclos = async () => {
        try {
            const response = await api.get('PmeCiclo', config);
            const ciclos = Array.isArray(response.data) ? response.data : [];
            const ciclosUnicos = Array.from(new Map(ciclos.map(ciclo => [ciclo.idCiclo, ciclo])).values());
    
            // Formatar os ciclos
            const ciclosFormatados = ciclosUnicos.map(ciclo => ({
                value: ciclo.idCiclo,
                id: ciclo.idCiclo,
                label: ciclo.nome
            }));
    
            // Atualizar o estado
            //setCiclosList(ciclosFormatados);
            return ciclosFormatados;
        } catch (err) {
            console.error('Erro ao buscar ciclos:', err); // Capturar e logar o erro
        }
    };

    const handleUpdateCiclos = async  (updatedData) => {
        const previousCiclos = await getCiclos(); // Obter ciclos já existentes

        const newCiclos = ['medicao', 'apuracao', 'pagamento']
            .map(key => updatedData[key])
            .filter(ciclo => ciclo)
            .map(ciclo => ({
                id: ciclo.idCiclo,
                label: ciclo.nome,
                value: ciclo.idCiclo,
            }));

        const combinedCiclos = [
            ...previousCiclos,
            ...newCiclos.filter(
                newCiclo => !previousCiclos.some(existing => existing.id === newCiclo.id)
            )
        ];

        setCiclosList(combinedCiclos);
    };

    const getCiclosTipos = async () => {
        try {
            const responseTipos = await api.get('PmeCiclo/tipos', config);
            const ciclosTipos = responseTipos.data || [];            
            const ciclosTiposFormatados = ciclosTipos.map(cicloTipo => ({
                value: cicloTipo.idCicloTipo,
                id: cicloTipo.idCicloTipo,
                label: cicloTipo.nome
            }));
            setCiclosTiposList(ciclosTiposFormatados);
        } catch (err) {}
    }

    const onGetCiclos = (selectedList, selectedItem) => {
        setSelectedCiclos((prevSelected) => {
            const updatedList = prevSelected ? [...prevSelected, selectedItem] : [selectedItem];
            return updatedList;
        });
        setIdCiclos(prev => [...prev, selectedItem.id]);
    };
    
    const onRemoveCiclos = (selectedList, removedItem) => {
        setSelectedCiclos((prevSelected) => {
            const updatedList = prevSelected?.filter(ciclo => ciclo.id !== removedItem.id) || [];
            return updatedList;
        });
        setIdCiclos(prev => prev.filter(id => id !== removedItem.id));
    };

    const getEmpresa = (currentValue, value) => {
        if (value === "clear" || value === null) {
            setEmpresaSelecionada(null);
            setEmpresaId(null);
        
            setFormGerais(prev => ({
                ...prev,
                idEmpresa: null
            }));
      
          return;
        }
      
        const empresaSelecionada = empresaList.find(o => o.idEmpresa == value);
      
        if (empresaSelecionada) {
            setEmpresaSelecionada(empresaSelecionada.description);
            setEmpresaId(empresaSelecionada.idEmpresa);
      
            setFormGerais(prev => ({
                ...prev,
                idEmpresa: empresaSelecionada.idEmpresa
            }));
        }
      };
      

    // ABA Perfil
    const handlePerfilPeritosChange = (currentValue) => {
        setFormPerfis((prev) => ({ ...prev, perfilPeritos: currentValue }));
    };

    const getPerfilPeritos = (currentValue, value) => {
        return;
    }

    const handlePerfilDesignersChange = (currentValue) => {
        setFormPerfis((prev) => ({ ...prev, perfilDesigners: currentValue }));
    };

    const handlePerfilAdministrativoChange = (currentValue) => {
        setFormPerfis((prev) => ({ ...prev, perfilAdministrativo: currentValue }));
    };

    const getacoesPerfis = (idPerfil) => {
        return (
            <span className="cursor-pointer color-icon-default m-1" onClick={() => { }} title="Excluir">
                <i className="fa fa-ban"></i>
            </span>
        );

    };

    const getPerfis = async () => {
        try {
            const responsePerfis = await api.get('PmePerfil', config);
            const perfisMap = responsePerfis.data || [];            
            const perfisFormatados = perfisMap.map(perfil => ({
                value: perfil.idPerfil,
                id: perfil.idPerfil,
                label: perfil.nome
            }));
            setPerfisList(perfisFormatados);
        } catch (err) {}
    }

    const handleUpdatePerfis = (updatedList) => {
        setPerfisList(updatedList.map(perfil => ({
            id: perfil.idPerfil,
            label: perfil.nome,
            value: perfil.idPerfil
        })));
    };

    const afterModalPerfilPmeOpen = () => { };
    const openModalPerfilPmeOpen = () => {
        setModalPerfilPme(true);
    };
    const closeModalPerfilPme = () => {
        setModalPerfilPme(false);
    }

    const afterModalPerfilTabelaPmeOpen = () => { };
    const openModalPerfilTabelaPmeOpen = (idPerfil, e) => {
        setModalPerfilTabela((prev) => ({ ...prev, idPerfil: idPerfil, idPrograma: idPrograma }));
        setModalPerfilTabelaPme(true);
    };
    const closeModalPerfilTabelaPme = (idPerfil, idPrograma) => {
        setModalPerfilTabela((prev) => ({ ...prev, idPerfil: '', idPrograma: '' }));
        setModalPerfilTabelaPme(false);
    }

    const handleChangeUpdateTablePerfil = async (perfilId, e) => {
        file = [e.target.files[0]];
        setFile(file);

        fileName = e.target.files[0].name;
        setFileName(fileName);

        Swal.fire({
            title: 'Aguarde...',
            html: 'Verificando Arquivo.',
            allowEscapeKey: false,
            allowOutsideClick: false,
            showConfirmButton: false,
            willOpen: () => {
                Swal.showLoading()
            },
        });

        let result = null;
        const formData = new FormData();
        formData.append("IdPerfil", perfilId);
        formData.append("File", e.target.files[0]);

        const config = {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        };

        try {
            const response = await api.post(`PmePerfil/import`, formData, config);
            result = response.data;

            Swal.close();
            e.target.value = '';
            setUploadedData((prevData) => ({
                ...prevData,
                [perfilId]: result.data, 
            }));

            setUploadedFileNames((prevNames) => ({
                ...prevNames,
                [perfilId]: fileName, 
            }));

            Swal.fire({
                title: 'Confirme os Dados',
                html: `
                <StyledTablePmePrograma>
                    <StyledTablePage>
                        <table 
                            className="table table-width table-bordered table-container" 
                            style="width: 100%; border-collapse: collapse; border: 1px solid #ddd; font-size: 14px; text-align: center;">
                            <thead style="background-color: #f2f2f2;">
                                <tr className="table-legend-info" style="border-bottom: 2px solid #ddd;">
                                    <th style="border: 1px solid #ddd; padding: 8px;">De</th>
                                    <th style="border: 1px solid #ddd; padding: 8px;">Até</th>
                                    <th style="border: 1px solid #ddd; padding: 8px;">Multiplicador</th>
                                </tr>
                            </thead>
                            <tbody id="swal-table-body">
                                <!-- O conteúdo será adicionado aqui dinamicamente -->
                            </tbody>
                        </table>
                    </StyledTablePage>
                </StyledTablePmePrograma>
                `,
                allowEscapeKey: false,
                allowOutsideClick: false,
                showConfirmButton: true,
                didOpen: () => {
                    const tableBody = document.getElementById('swal-table-body');
                    if (tableBody) {
                        const rows = result.data.map((item, index) => `
                            <tr style="background-color: ${index % 2 === 0 ? '#ffffff' : '#f9f9f9'}; border-bottom: 1px solid #ddd;">
                                <td style="border: 1px solid #ddd; padding: 8px;">${item.de.toFixed(2)}</td>
                                <td style="border: 1px solid #ddd; padding: 8px;">${item.ate.toFixed(2)}</td>
                                <td style="border: 1px solid #ddd; padding: 8px;">${item.multiplicador.toFixed(2)}</td>
                            </tr>
                        `).join('');
                        tableBody.innerHTML = rows;
                    }
                }
            });

            return result;
        } catch (err) {
            Swal.close();

            Swal.fire({
                title: "Atenção",
                text: "Não foi possível processar essa planilha, tente novamente em instantes e caso o erro persista contacte um de nossos administradores do sistema!",
                icon: "error",
                confirmButtonText: "OK",
            });

            e.target.value = '';
            return result;
        }
    }

    // ABA Gatilhos
    const handleHoraMediaFaturadaGlobalChange = (currentValue) => {
        const decimalValue = parseFloat(currentValue) || 0;
        setFormGatilhos((prev) => ({ ...prev, horaMediaFaturadaGlobal: decimalValue }));
    };

    const handleHoraMediaFaturadaUnidadeNegocioChange = (currentValue) => {
        const decimalValue = parseFloat(currentValue) || 0;
        setFormGatilhos((prev) => ({ ...prev, horaMediaFaturadaUnidadeNegocio: decimalValue }));
    };

    const handleHoraFaturadaIndividualChange = (currentValue) => {
        const decimalValue = parseFloat(currentValue) || 0;
        setFormGatilhos((prev) => ({ ...prev, horaFaturadaIndividual: decimalValue }));
    };

    // ABA Metas
    const getProfissionais = async () => {
        let profissionais = null;
        try {
            const response = await api.get(`PmeProfissionalPME`, config);
            profissionais = response.data.data;
        } catch (err) { }
        return profissionais;
    }

    const getProfissional = (currentValue, value) => {
        if (value === null || value === "") {
            profissional = null;
            idProfissional = null;
            setProfissional(profissional);
            setIdProfissional(idProfissional);
            return;
        }

        var profissionalResult = profissionaisList.filter(function (o) {
            return o.idProfissional == value;
        });
        profissional = profissionalResult[0].profissional;
        idProfissional = profissionalResult[0].idProfissional;
        setProfissional(profissional);
        setIdProfissional(idProfissional);
    }

    const getCategoriaProfissional = async () => {
        try {
            const response = await api.get('PmePerfil', config);
            const perfis = response.data || [];            
            const perfisFormatados = perfis.map(perfil => ({
                value: perfil.idPerfil,
                id: perfil.idPerfil,
                label: perfil.nome
            }));
            setPerfisList(perfisFormatados);
        } catch (err) {}
    }

    const handleHMFGlobalChange = (currentValue) => {
        setFormMetas((prev) => ({ ...prev, HMFGlobal: convertDecimal(currentValue) }));
    };

    const handleHMFUnidadeNegocioChange = (currentValue) => {
        setFormMetas((prev) => ({ ...prev, HMFUnidadeNegocio: convertDecimal(currentValue) }));
    };

    const handleHMFIndividualChange = (currentValue) => {
        setFormMetas((prev) => ({ ...prev, HMFIndividual: convertDecimal(currentValue) }));
    };

    const handleSuperHMFGlobalChange = (currentValue) => {
        setFormMetas((prev) => ({ ...prev, superHMFGlobal: convertDecimal(currentValue) }));
    };

    const handleSuperHMFUnidadeNegocioChange = (currentValue) => {
        setFormMetas((prev) => ({ ...prev, superHMFUnidadeNegocio: convertDecimal(currentValue) }));
    };

    const handleSuperHMFIndividualChange = (currentValue) => {
        setFormMetas((prev) => ({ ...prev, superHMFIndividual: convertDecimal(currentValue) }));
    };

    const handleAdmRHDChange = (currentValue) => {
        setFormMetas((prev) => ({ ...prev, admRHD: convertDecimal(currentValue) }));
    };

    //ABA REGRAS
    const handleToggleChangeAplicarPercTempo = (status) => {
        setFormRegras((prevState) => ({
            ...prevState,
            aplicarPercTempo: status,
        }));
    };

    const handleToggleChangeAplicarPercFranquia = (status) => {
        setFormRegras((prevState) => ({
            ...prevState,
            aplicarPercFranquia: status,
        }));
    };

    const handleToggleChangeAplicarPercProfissionalDesigner = (status) => {
        setFormRegras((prevState) => ({
            ...prevState,
            aplicarPercProfissionalDesigner: status,
        }));
    };

    const handlePercFranquia1MesChange = (currentValue) => {
        const decimalValue = parseFloat(currentValue) || 0;
        setFormRegras((prev) => ({ ...prev, percFranquia1Mes: decimalValue }));
    };

    const handlePercFranquia2Mes3MesChange = (currentValue) => {
        const decimalValue = parseFloat(currentValue) || 0;
        setFormRegras((prev) => ({ ...prev, percFranquia2Mes3Mes: decimalValue }));
    };

    const handleGatilhoMeritoChange = (currentValue) => {
        const decimalValue = parseFloat(currentValue) || 0;
        setFormRegras((prev) => ({ ...prev, gatilhoMerito: decimalValue }));
    };

    const handleToggleChangeRegraHFMu = (name, status) => { 
        setFormRegras((prevState) => ({
            ...prevState,
            [name]: status, // Atualiza dinamicamente o campo com base no nome
        }));
    };

    const getMeritos = async (idProg) => {
        try {
            const meritos = await api.get(`PmeRegra/merito/${idProg}`);
            setMeritos(meritos.data);
        } catch (err) {
            setMeritos([]);
        }
    };

    const getAreasMerito = async () => {
        try {
            const response = await api.get('Empresa/listareas', config);
            const areas = response.data.data;            
    
            // Mapeia todas as áreas diretamente
            const todasAreas = areas
                .filter(area => !areasExcluidas.includes(area.description))
                .map(area => ({
                    idArea: area.idArea,
                    description: area.description
            }));
    
            setAreas(todasAreas);
    
        } catch (err) {
            console.error("Erro ao buscar áreas:", err);
        }
    };

    const getAreas = async () => {
        try {
            const response = await api.get('Empresa/listareas', config);
            const areas = response.data.data;
    
            // Criar um conjunto para armazenar áreas gestoras únicas
            const idAreasGestoras = new Map();
    
            areas.forEach((item) => {
                if (item.idAreaGestora !== null) {
                    // Buscar o nome da área gestora correspondente
                    const areaGestora = areas.find(area => area.idArea === item.idAreaGestora);
                    if (areaGestora && !idAreasGestoras.has(item.idAreaGestora)) {
                        idAreasGestoras.set(item.idAreaGestora, areaGestora.description);
                    }
                }
            });
    
            // Converter Map para Array de objetos
            const areasGestoras = [...idAreasGestoras].map(([id, description]) => ({ idAreaGestora: id, description }));
    
            // Se quiser armazenar o resultado no estado:
            setAreasGestoras(areasGestoras);
    
        } catch (err) {
            console.error("Erro ao buscar áreas:", err);
        }
    };

    const afterModalRegrasMeritoPme = () => { };
    const openModalRegrasMeritoPme = (index) => {
        console.log("index", index);
        if(index != -1) {
            setMeritoEdit(true);
            setIdRegraMerito(index);
        }
        else {
            setMeritoEdit(false);
        }
        setModalRegrasMeritoPme(true);
    };

    const closeModalRegrasMeritoPme = async () => {
        await getMeritos(idPrograma);
        setModalRegrasMeritoPme(false);
    };

    const inativarRegraMerito = async (id) => {
        const result = await Swal.fire({
            title: 'Tem certeza?',
            text: 'Você deseja realmente inativar esta regra?',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d33',
            cancelButtonColor: '#3085d6',
            confirmButtonText: 'Sim, inativar!',
            cancelButtonText: 'Cancelar'
        });
    
        if (!result.isConfirmed) return;
    
        try {
            await api.put(`PmeRegra/merito/inativar/${id}`);
            Swal.fire({
                title: "Sucesso",
                text: "Regra inativada com sucesso",
                icon: "success",
                showConfirmButton: false,
                timer: 1500,
            });            

            await getMeritos(idPrograma);
        } catch (error) {
            console.log(error);
            Swal.fire("Erro", "Erro ao inativar regra", "error");
        }
    };
    
    //ABA PROFISSIONAIS
    const carregarUsuarios = async () => {
        setIsLoading(true);
        try {
            const formValues = {
                nome: usuarioNome ?? null,
            };
            const lista = await getUsuarios(formValues, currentPage, pageSize);
            setListaUsuariosData(lista);
        } finally {
            setIsLoading(false);
        }
    };

    const handleCheckboxUsuariosChange = (userId) => {
        setSelectedUsers((prevSelected) => {
            if (prevSelected.includes(userId)) {
                return prevSelected.filter((idUsuario) => idUsuario !== userId);
            } else {
                return [...prevSelected, userId];
            }
        });
    };

    const handleSelectAll = (checked) => {
        if (checked) {
            setSelectedUsers(listaUsuariosData.data.map((user) => user.idUsuario));
        } else {
            setSelectedUsers([]);
        }
    };

    const calcularPorcentagemTempoXAdmissao = (idProfissional, dataAdmissao, dataDemissao) => {
        if (!dataAdmissao) return '0.00';
        let profissional = listaUsuariosData.data.find((usuario) => usuario.idProfissional === idProfissional);
        let resultadoFinal = 1;

        const admissao = new Date(dataAdmissao);
        const demissao = dataDemissao ? new Date(dataDemissao) : null;
        let inicioPeriodo = new Date(formGerais.dataInicio);
        const fimPeriodo = new Date(formGerais.dataFim);

        if (profissional.participacaoCalibracaoTempo) {
            const diasNoMesAdmissao = new Date(admissao.getFullYear(), admissao.getUTCMonth() + 1, 0).getDate();
            const diasTrabalhadosNoMes = diasNoMesAdmissao - admissao.getDate() + 1;
            const porcentagemMesAdmissao = diasTrabalhadosNoMes / diasNoMesAdmissao;

            const mesesRestantes = Math.max(0, fimPeriodo.getMonth() - admissao.getMonth());
            const totalMesesPrograma = (fimPeriodo.getFullYear() - inicioPeriodo.getFullYear()) * 12 + (fimPeriodo.getMonth() - inicioPeriodo.getMonth()) + 1;
            const tempoTrabalhado = (porcentagemMesAdmissao + mesesRestantes) / totalMesesPrograma;
            resultadoFinal = tempoTrabalhado;
        }

        // if (dataDemissao !== null && dataDemissao !== '') {
        //     if(profissional.participacaoCalibracaoTempo) {
        //         let _inicioPeriodo = inicioPeriodo;
        //         if (admissao >= inicioPeriodo && demissao <= fimPeriodo) { 
        //             _inicioPeriodo = admissao;
        //         }

        //         const diasNoMesSaida = new Date(demissao.getFullYear(), demissao.getUTCMonth() + 1, 0).getDate();
        //         const diasTrabalhadosNoMes = demissao.getDate();
        //         const porcentagemMesSaida = diasTrabalhadosNoMes / diasNoMesSaida;

        //         const mesesTrabalhados = Math.max(0, demissao.getMonth() - inicioPeriodo.getMonth());
        //         const totalMesesPrograma = (fimPeriodo.getFullYear() - inicioPeriodo.getFullYear()) * 12 + (fimPeriodo.getMonth() - inicioPeriodo.getMonth()) + 1;
        //         const tempoTrabalhado = (porcentagemMesSaida + mesesTrabalhados) / totalMesesPrograma;

        //         resultadoFinal = tempoTrabalhado;
        //     }
        // }

        if (dataDemissao !== null && dataDemissao !== '') {
            if (profissional.participacaoCalibracaoTempo) {
                
                let porcentagemMesEntrada = 0;
                let ajusteMesCheio = 0; // Usado para não contar o mês de entrada duas vezes

                if (admissao >= inicioPeriodo && demissao <= fimPeriodo) { 
                    inicioPeriodo = admissao;

                    // Calcula os dias quebrados do novo início (admissão)
                    const diasNoMesEntrada = new Date(inicioPeriodo.getFullYear(), inicioPeriodo.getMonth() + 1, 0).getDate();
                    const diasTrabEntrada = diasNoMesEntrada - inicioPeriodo.getDate() + 1;
                    
                    porcentagemMesEntrada = diasTrabEntrada / diasNoMesEntrada;
                    ajusteMesCheio = 1; // Remove 1 mês da conta cheia, pois ele agora é calculado como fração acima
                }

                const diasNoMesSaida = new Date(demissao.getFullYear(), demissao.getMonth() + 1, 0).getDate();
                const diasTrabalhadosNoMes = demissao.getDate(); 
                const porcentagemMesSaida = diasTrabalhadosNoMes / diasNoMesSaida;

                // Subtraímos o 'ajusteMesCheio' para a matemática fechar
                const mesesTrabalhados = Math.max(0, (demissao.getMonth() - inicioPeriodo.getMonth()) - ajusteMesCheio);
                
                // Recalcula o total do programa caso o inicioPeriodo tenha mudado
                const dataInicioOriginal = new Date(formGerais.dataInicio);
                const totalMesesPrograma = (fimPeriodo.getFullYear() - dataInicioOriginal.getFullYear()) * 12 + (fimPeriodo.getMonth() - dataInicioOriginal.getMonth()) + 1;
                
                // Soma: Fração Entrada (se houver) + Fração Saída + Meses do Meio
                const tempoTrabalhado = (porcentagemMesEntrada + porcentagemMesSaida + mesesTrabalhados) / totalMesesPrograma;

                resultadoFinal = tempoTrabalhado;
            }
        }

        return (resultadoFinal);
    };

    const calcularPorcentagemProfissionalFranquia = (idProfissional, dataAdmissao, percProfissional) => {
        let profissional = listaUsuariosData.data.find((usuario) => usuario.idProfissional === idProfissional);
        let resultadoFinal = 1;
        
        if(profissional.participacaoFranquia) {
            const admissao = new Date(dataAdmissao);
            const inicioPeriodo = new Date(formGerais.dataInicio)
            const fimPeriodo = new Date(formGerais.dataFim);
            inicioPeriodo.setHours(0, 0, 0, 0);
            fimPeriodo.setHours(23, 59, 59, 999);

            const diasNoMesAdmissao = new Date(admissao.getFullYear(), admissao.getUTCMonth() + 1, 0).getDate();
            const diasTrabalhadosNoMes = diasNoMesAdmissao - admissao.getDate() + 1;
            const porcentagemMesAdmissao = diasTrabalhadosNoMes / diasNoMesAdmissao;
            
            const mesesRestantes = Math.max(0, fimPeriodo.getMonth() - admissao.getMonth());
            const totalMesesPrograma = (fimPeriodo.getFullYear() - inicioPeriodo.getFullYear()) * 12 + (fimPeriodo.getMonth() - inicioPeriodo.getMonth()) + 1;
            const tempoTrabalhado = (porcentagemMesAdmissao + mesesRestantes) / totalMesesPrograma;

            const mesesTrabalhados = (fimPeriodo.getFullYear() - inicioPeriodo.getFullYear()) * 12 + (fimPeriodo.getMonth() - inicioPeriodo.getMonth()) + 1;
            const resultado = (porcentagemMesAdmissao + mesesRestantes);

            //Aplicar somente se flag estiver marcada
            const peso1Mes = 0 * Math.min(1, mesesTrabalhados);
            const peso2e3Meses = 0.7 * Math.max(0, Math.min(2, mesesTrabalhados - 1)) / resultado;
            const pesoRestante = 1 * (resultado - 3) / resultado; 

            resultadoFinal = peso1Mes + peso2e3Meses + pesoRestante;
        }  

        if(percProfissional < 100)
        {
            if(profissional.participacaoFranquia) {
                resultadoFinal = (percProfissional * resultadoFinal) / 100;
            } else {
                resultadoFinal = percProfissional / 100;
            }
        }
        
        return (resultadoFinal);        
    };

    const calcularCalibracaoTotal = (idProfissional, dataAdmissao, dataDemissao, percProfissional = 100) => {
        const percentTempo = calcularPorcentagemTempoXAdmissao(idProfissional, dataAdmissao, dataDemissao);
        const percentFranquia = calcularPorcentagemProfissionalFranquia(idProfissional, dataAdmissao, percProfissional);

        return (percentTempo * percentFranquia);
    };

    const calcularGatilhoIndividual = (valorGatilho, dataAdmissao) => {
        if (!valorGatilho || !dataAdmissao) return '0.00';
    
        const admissao = new Date(dataAdmissao);
        const fimPeriodo = new Date();

        const primeiroNovembro = new Date(fimPeriodo.getFullYear(), 10, 1);
        if (admissao >= primeiroNovembro) {
            return '0.00';
        }
    
        const mesesTrabalhados = 
            (fimPeriodo.getFullYear() - admissao.getFullYear()) * 12 +
            (fimPeriodo.getMonth() - admissao.getMonth());
    
        if (mesesTrabalhados >= 12) {
            return valorGatilho.toFixed(2);
        }

        const gatilhoProporcional = (mesesTrabalhados / 12) * valorGatilho;    
        return gatilhoProporcional.toFixed(2);
    };

    const handleToggleChangeParticipacaoFranquia = (idProfissional, status) => {
        setListaUsuariosData((prevState) => {
            const updatedData = _.cloneDeep(prevState.data).map((usuario) => {
                if (usuario.idProfissional === idProfissional) {
                    const returnPercProfissionalFranquia = status
                        ? calcularPorcentagemProfissionalFranquia(
                            idProfissional,
                            usuario.dataAdmissao,
                            usuario.percProfissional
                        )
                        : 100;
    
                    return {
                        ...usuario,
                        participacaoFranquia: status ? 1 : 0,
                        calibracaoPercProfissionalFranquia: returnPercProfissionalFranquia
                    };
                }
                return usuario;
            });
    
            return {
                ...prevState,
                data: updatedData,
            };
        });
    };

    const handleToggleChangeParticipacaoCalibracaoTempo = (idProfissional, status) => {
        setListaUsuariosData((prevState) => {
            const updatedData = _.cloneDeep(prevState.data).map((usuario) => {
                if (usuario.idProfissional === idProfissional) {
                    const returnParticipacaoCalibracaoTempo = status
                        ? calcularPorcentagemTempoXAdmissao(
                            idProfissional,
                            usuario.dataAdmissao,
                            usuario.dataDemissao
                        )
                        : 100;
    
                    return {
                        ...usuario,
                        participacaoCalibracaoTempo: status ? true : false                 
                    };
                }
                return usuario;
            });
    
            return {
                ...prevState,
                data: updatedData,
            };
        });
    };    

    const handleToggleChangeParticipacaoCalculo = (idProfissional, status) => {
        setListaUsuariosData((prevState) => ({
            ...prevState,
            data: prevState.data.map((usuario) =>
                usuario.idProfissional === idProfissional
                    ? { ...usuario, participacaoCalculo: status }
                    : usuario
            ),
        }));
    };

    const afterModalProfissionalPmeOpen = () => { };
    const openModalProfissionalPmeOpen = () => {
        setModalProfissionalPme(true);    
    };
    const closeModalProfissionalPme = () => {
        savePrograma();
        setModalProfissionalPme(false);
    }

    //
    const getacoes = (idProfissional) => {
        return (
            <Flex >
                {/* <span className="cursor-pointer color-icon-default m-1" onClick={() => { }} title="Editar Detalhes">
                    <i className="fa fa-edit" aria-hidden="true"></i>
                </span> */}
                <span className="cursor-pointer color-icon-default m-1" onClick={() => { handleDeleteProfissional(idProfissional, idPrograma) }} title="Excluir">
                    <i className="fa fa-ban"></i>
                </span>
            </Flex>
        );

    };

    const delProfissional = async (idProfissional, idPrograma) => {
        try {
            await api.delete(`PmeProfissionalPME/profissional/${idProfissional}/programa/${idPrograma}`);
            
            Swal.fire({
                title: "Sucesso",
                text: "Profissional Removido com sucesso!",
                icon: "success",
                showConfirmButton: false,
                timer: 1500,
            });
    
            await getProfissionais(); // Atualiza a lista após remoção
        } catch (error) {
            //console.error("Erro ao remover profissional:", error);
            Swal.fire({
                title: "Erro",
                text: "Não foi possível remover o profissional. Tente novamente.",
                icon: "error",
                confirmButtonText: "OK",
            });
        }
    };

    const handleDeleteProfissional = (idProfissional, idPrograma) => {
        Swal.fire({
            title: "Tem certeza?",
            text: "Essa ação não poderá ser desfeita!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#d33",
            cancelButtonColor: "#3085d6",
            confirmButtonText: "Sim, remover!",
            cancelButtonText: "Cancelar",
        }).then((result) => {
            if (result.isConfirmed) {
                delProfissional(idProfissional, idPrograma);
                getProfissionaisPrograma(idPrograma);
            }
        });
    };

    const getPrograma = async(id) => {
        try {
            const response = await api.get(`PmePrograma/${id}`);
            const prog = response?.data?.data;
            setFormGerais({
                nomePrograma: prog.nomePrograma || '',
                dataInicio: prog.dataInicio ? new Date(prog.dataInicio) : null,
                dataFim: prog.dataFim ? new Date(prog.dataFim) : null,
                anexoPath: prog.anexoPath || '',
                ciclosIds: prog.ciclosIds || '',
                idEmpresa: prog.idEmpresa || ''
            });

            setFormGatilhos({
                idGatilho: prog.gatilhos[0].idGatilho,
                horaFaturadaIndividual: prog.gatilhos[0].horaFaturadaIndividual,
                horaMediaFaturadaGlobal: prog.gatilhos[0].horaMediaFaturadaGlobal,
                horaMediaFaturadaUnidadeNegocio: prog.gatilhos[0].horaMediaFaturadaUnidadeNegocio
            });

            setFormMetas({
                idMeta: prog.metas[0].idMeta,
                HMFGlobal: prog.metas[0].hmfGlobal,
                HMFUnidadeNegocio: prog.metas[0].hmfUnidadeNegocio,
                HMFIndividual: prog.metas[0].hmfIndividual,
                superHMFGlobal: prog.metas[0].superHMFGlobal,
                superHMFUnidadeNegocio: prog.metas[0].superHMFUnidadeNegocio,
                superHMFIndividual: prog.metas[0].superHMFIndividual,
                admRHD: prog.metas[0].admRHD,
            });

            setFormRegras({
                idRegra: prog.regras[0].idRegra,
                aplicarPercTempo: prog.regras[0].aplicarPercTempo,
                aplicarPercFranquia: prog.regras[0].aplicarPercFranquia,
                aplicarPercProfissionalDesigner: prog.regras[0].aplicarPercProfissionalDesigner,
                percFranquia1Mes: prog.regras[0].percFranquia1Mes,
                percFranquia2Mes3Mes: prog.regras[0].percFranquia2Mes3Mes,
                gatilhoMerito: prog.regras[0].gatilhoMerito,
            });
            
        } catch (err) {
            console.error("API Error:", err);
        }
    };

    const getProfissionaisPrograma = async(id) => {
        const response = await api.get(`PmeProfissionalPME/profissionais/programa/${id}`);
        setListaUsuariosData(response.data);        
    };

    const handlePercProfissionalChange = (idProfissional, field, newValue) => {
        setListaUsuariosData((prevState) => ({
            ...prevState,
            data: prevState.data.map((usuario) =>
                usuario.idProfissional === idProfissional
                    ? { 
                        ...usuario, 
                        [field]: parseFloat(newValue),
                        participacaoFranquia: parseFloat(newValue) < 100 ? 1 : 0
                     }
                    : usuario
            ),
        }));
    };

    const handleChangeCalibTotal = (idProfissional, dataAdmissao, dataDemissao, newValue) => {
        const calcularCalibracaoTotal = (idProfissional, dataAdmissao, dataDemissao, newValue)
    }

    const transformTabelasMultiplicadores = (originalData) => {
        const result = [];
      
        originalData.forEach((multiplicadorGroup) => {
            Object.entries(multiplicadorGroup).forEach(([categoriaId, entries]) => {
                entries.forEach((entry) => {
                    result.push({
                        IdPerfil: parseInt(categoriaId, 10),
                        De: entry.de,
                        Ate: entry.ate,
                        Multiplicador: entry.multiplicador
                    });
                });
            });
        });      
        return result;
    };

    //init
    useEffect(() => {
        const asyncFn = async () => {
            try {
                setIsLoading(true);
                await getCiclos();
                await getCiclosTipos();
                await getPerfis();
                await getAreas();
                await getAreasMerito();                
                
                const fetchCiclos = async () => {
                    const ciclos = await getCiclos();
                    setCiclosList(ciclos);
                };

                fetchCiclos();
    
                if (idPrograma) {               
                    setIsEdit(true);
                    setIdProgramaParam(idPrograma);                    
                    await getPrograma(idPrograma);
                    await getProfissionaisPrograma(idPrograma);
                    await getMeritos(idPrograma);
                } else {
                    await carregarUsuarios();
                }

                const empresas = localStorage.getItem('empresasUsuario') ?
                JSON.parse(localStorage.getItem('empresasUsuario'))
                    : [];

                const empresaList = await getEmpresas();
                if (!!empresaList) {
                    setEmpresaList(empresaList.filter(empresa => empresas.indexOf(empresa.idEmpresa) > -1))
                }

            } catch (err) {
                console.error("Erro na inicialização:", err.message);
            } finally {
                setIsLoading(false);
            }           
        }
        asyncFn()
    }, [idPrograma]);

    useEffect(() => {
        if (ciclosList && formGerais?.ciclosIds) {
            const ciclosIdsArray = formGerais.ciclosIds?.split(',').map(id => parseInt(id, 10)) || [];
            const ciclosFiltrados = ciclosList.filter(ciclo => ciclosIdsArray.includes(ciclo.id));
            setSelectedCiclos(ciclosFiltrados);
        }
    }, [ciclosList, formGerais])

    const registrationSuccess = () => {
        Swal.fire({
            title: "Sucesso",
            text: "Cadastro realizado com sucesso",
            icon: "success",
            showConfirmButton: false,
            timer: 2000,
            timerProgressBar: true,
        });
    }

    const updateRegistrationSuccess = () => {
        getProfissionaisPrograma(idPrograma);
        Swal.fire({
            title: "Sucesso",
            text: "Cadastro atualizado com sucesso",
            icon: "success",
            showConfirmButton: false,
            timer: 2000,
            timerProgressBar: true,
        });
        history.push(`/pme-programas/edit/${parseInt(idPrograma)}`);
    }

    const limpaCampos = () => {
        setIdCiclos([]);
        setCiclosList([]);
        setSelectedUsers([]);
        setFormGerais({
            nomePrograma: '',
            dataInicio: '',
            dataFim: '',
            anexoPath: '',
            idEmpresa: ''
        });
        setFormPerfis({
            perfilPeritos: '',
            perfilDesigners: '',
            perfilAdministrativo: ''
        });
        setFormGatilhos({
            horaMediaFaturadaGlobal: 0.00,
            horaMediaFaturadaUnidadeNegocio: 0.00,
            horaFaturadaIndividual: 0.00
        });
        setFormMetas({
            HMFGlobal: '',
            HMFUnidadeNegocio: '',
            HMFIndividual: '',
            superHMFGlobal: '',
            superHMFUnidadeNegocio: '',
            superHMFIndividual: '',
            admRHD: '',
        });
        setFormRegras({
            aplicarPercTempo: false,
            aplicarPercFranquia: false,
            aplicarPercProfissionalDesigner: false,
            percFranquia1Mes: '',
            percFranquia2Mes3Mes: '',
            gatilhoMerito: '',
        });
    };

    const campoObrigatorio = (campo) => {
        Swal.fire({
            title: "Atenção",
            html: `Informe <b>${campo}</b>`,
            icon: "warning",
            confirmButtonText: "OK",
        });        
    };

    const formatarData = (data) => {
        if (!data) return null; // Retorna null se a data não for válida
    
        const dataObj = new Date(data);
        const ano = dataObj.getFullYear();
        const mes = String(dataObj.getMonth() + 1).padStart(2, '0'); // Mês começa do 0
        const dia = String(dataObj.getDate()).padStart(2, '0');
    
        return `${ano}-${mes}-${dia}T03:00:00.000Z`;
    };

    const savePrograma = async () => {
        if (!formGerais.nomePrograma) { campoObrigatorio("Nome do Programa"); return false; }
        if (!formGerais.dataInicio) { campoObrigatorio("Data Inicial"); return false; }
        if (!formGerais.dataFim) { campoObrigatorio("Data Final"); return false; }
        if (!formGerais.idEmpresa) { campoObrigatorio("Empresa"); return false; }
        //if (idCiclos.length == 0 && (selectedCiclos == null)) { campoObrigatorio("Selecione pelo menos 1 Ciclo"); return false; }
        if (!formGatilhos.horaMediaFaturadaGlobal) { campoObrigatorio("Hora Média Faturada Global (HMFg)"); return false; }
        if (!formGatilhos.horaMediaFaturadaUnidadeNegocio) { campoObrigatorio("Hora Média Faturada Unidades de Negócio (HMFu)"); return false; }
        if (!formGatilhos.horaFaturadaIndividual) { campoObrigatorio("Hora Faturada Individual (HFi)"); return false; }
        if (!formMetas.HMFGlobal) { campoObrigatorio("Meta HMF Global"); return false; }
        if (!formMetas.HMFUnidadeNegocio) { campoObrigatorio("Meta HMF Un. de Negócios"); return false; }
        if (!formMetas.HMFIndividual) { campoObrigatorio("Meta HMF Individual"); return false; }
        if (!formMetas.superHMFGlobal) { campoObrigatorio("Super Meta HMF Global"); return false; }
        if (!formMetas.superHMFUnidadeNegocio) { campoObrigatorio("Super Meta HMF Un. de Negócios"); return false; }
        if (!formMetas.superHMFIndividual) { campoObrigatorio("Super Meta HMF Individual"); return false; }
        if (!formMetas.admRHD) { campoObrigatorio("Meta de % RHD"); return false; }

        let payload = {            
            nomePrograma: formGerais.nomePrograma,
            dataInicio: formatarData(formGerais.dataInicio),
            dataFim: formatarData(formGerais.dataFim),
            anexoPath: formGerais.anexoPath,
            idEmpresa: formGerais.idEmpresa,
            ciclos: idCiclos.join(","),

            perfilPeritos: formPerfis.perfilPeritos,
            perfilDesigners: formPerfis.perfilDesigners,
            perfilAdministrativo: formPerfis.perfilAdministrativo,

            tabelasMultiplicadores: transformTabelasMultiplicadores([uploadedData]),

            horaMediaFaturadaGlobal: formGatilhos.horaMediaFaturadaGlobal,
            horaMediaFaturadaUnidadeNegocio: formGatilhos.horaMediaFaturadaUnidadeNegocio,
            horaFaturadaIndividual: formGatilhos.horaFaturadaIndividual,

            HMFGlobal: formMetas.HMFGlobal,
            HMFUnidadeNegocio: formMetas.HMFUnidadeNegocio,
            HMFIndividual: formMetas.HMFIndividual,
            superHMFGlobal: formMetas.superHMFGlobal,
            superHMFUnidadeNegocio: formMetas.superHMFUnidadeNegocio,
            superHMFIndividual: formMetas.superHMFIndividual,
            admRHD: formMetas.admRHD,

            aplicarPercTempo: formRegras.aplicarPercTempo,
            aplicarPercFranquia: formRegras.aplicarPercFranquia,
            aplicarPercProfissionalDesigner: formRegras.aplicarPercProfissionalDesigner,
            percFranquia1Mes: formRegras.percFranquia1Mes,
            percFranquia2Mes3Mes: formRegras.percFranquia2Mes3Mes,
            gatilhoMerito: formRegras.gatilhoMerito,

            profissionais: selectedUsers.join(",")
        };
        
        if (isEdit) {
            var combinedIds = [];
            combinedIds = [...idCiclos ];

            if (selectedCiclos != null) {
                var combinedIds = [];
                combinedIds = [
                    ...idCiclos,
                    ...selectedCiclos.map(ciclo => ciclo.id.toString())
                ];
            }

            payload["ciclos"] = combinedIds.join(",");
            payload["idPrograma"] = parseInt(idPrograma);
            payload["idPerfil"] = parseInt(formPerfis.idPerfil);
            payload["idGatilho"] = parseInt(formGatilhos.idGatilho);
            payload["idMeta"] = parseInt(formMetas.idMeta);
            payload["idRegra"] = parseInt(formRegras.idRegra);
            payload["tabelaProfissionais"] = listaUsuariosData.data;

            // INÍCIO DA CORREÇÃO: Injetando as calibrações no payload conforme as funções existentes
            const profissionaisComCalibracao = listaUsuariosData.data.map(usuario => {
                
                // Usamos as funções exatas do seu código para não mudar a regra
                const cTempo = calcularPorcentagemTempoXAdmissao(
                    usuario.idProfissional, 
                    usuario.dataAdmissao, 
                    usuario.dataDemissao
                ); 

                const cFranquiaProf = calcularPorcentagemProfissionalFranquia(
                    usuario.idProfissional, 
                    usuario.dataAdmissao, 
                    usuario.percProfissional
                );

                const cTotal = calcularCalibracaoTotal(
                    usuario.idProfissional,
                    usuario.dataAdmissao,
                    usuario.dataDemissao,
                    usuario.percProfissional
                );

                return {
                    ...usuario,
                    // Enviamos os valores divididos por 100 para o C# receber como decimal (ex: 0.91071)
                    // Isso casa com o seu banco DECIMAL(18, 5)
                    calibracaoTotal: cTotal, 
                    calibracaoTempo: cTempo, 
                    calibracaoPercProfissionalFranquia: cFranquiaProf 
                };
            });

            payload["tabelaProfissionais"] = profissionaisComCalibracao;
            // FIM DA CORREÇÃO

            Swal.fire({
                title: 'Aguarde...',
                html: 'Atualizando Programa...',
                allowEscapeKey: false,
                allowOutsideClick: false,
                showConfirmButton: false,
                willOpen: () => {
                    Swal.showLoading()
                },
            });
            
            await api.put('PmePrograma/atualizar', payload);
            Swal.close();
            setActiveTab(0);
            updateRegistrationSuccess();
        } else {
            try {
                Swal.fire({
                    title: 'Aguarde...',
                    html: 'Salvando Programa...',
                    allowEscapeKey: false,
                    allowOutsideClick: false,
                    showConfirmButton: false,
                    willOpen: () => {
                        Swal.showLoading()
                    },
                });
                var result = await api.put('PmePrograma/salvar', payload);
                limpaCampos();
                Swal.close();
                setActiveTab(0);
                registrationSuccess();
                history.push(`/pme-programas/edit/${result.data.programaId}`);
            }
            catch{
                Swal.close();
            }

        }
    };

    const voltar = async () => {
        history.push(`/pme-programas`)
    }

    // Modal
    const afterModalCicloPmeOpen = () => { };
    const openModalCicloPmeOpen = () => {
        setModalCicloPme(true);
    };
    const closeModalCicloPme = () => {
        setModalCicloPme(false);
    }

    return (
        <section>
            <main className="d-flex">
                {isDesktop && <Menu />}
                <StyledDefaultPage>
                    <div className="w-100 d-flex justify-content-between align-items-center">
                        <div className="title-row">
                            <h5 className="title-row-header">{!isEdit ? 'PME - Novo Programa' : 'PME - Editar Programa'} </h5>
                            {/* <span title="Atualizar" className="cursorPointer" onClick={refreshData}><IconRefresh color={"#EE4B21"} /></span> */}
                        </div>
                        <div>
                            <button type="button" className='default-button-red me-2' onClick={() => savePrograma()}>{ !isEdit ? 'Salvar' : 'Atualizar' } Programa</button>
                            <input type="button" className='default-button' value='Voltar' onClick={voltar} />                            
                        </div>
                    </div>
                    <StyledProgramasFormPmePage>
                        <Tabs className="timesheet m-0" selectedIndex={activeTab} onSelect={(index) => setActiveTab(index)}>
                            <TabList>
                                <Tab ><span className="mx-3">Dados Gerais</span></Tab>
                                <Tab ><span className="mx-3">Multiplicadores</span></Tab>
                                <Tab ><span className="mx-3">Gatilhos</span></Tab>
                                <Tab ><span className="mx-3">Metas</span></Tab>
                                <Tab ><span className="mx-3">Regras</span></Tab>
                                <Tab ><span className="mx-3">{ !isEdit ? 'Profissionais' : 'Calibração' }</span></Tab>
                                {/* <Tab ><span className="mx-3">Configurações</span></Tab> */}
                            </TabList>
                            <div className="cardTabPme">
                                {/* DADOS GERAIS */}
                                <TabPanel >
                                    <div className="card">
                                        <StyledForm >
                                            <div className='row justify-align-content-around  mt-3'>
                                                <div className="col-sm-12 col-md-8 col-lg-8 col-xxl-8">
                                                    <MemorizedDynamicInput 
                                                        ref={nomeProgramaRef} 
                                                        placeholder={''} 
                                                        label={'Nome do Programa *'} 
                                                        name={'nomePrograma'} 
                                                        paramMethod={handleNomeProgramaChange} 
                                                        value={formGerais.nomePrograma} />
                                                </div>
                                                <div className="position-relative col-sm-12  col-md-4 col-lg-4 ">
                                                    <div className="position-relative form-group col-sm-12 col-md-6 col-lg-6 pl-0" style={{ float: 'left' }}>
                                                        <DatePicker
                                                            dateFormat="dd/MM/yyyy"
                                                            locale="pt-BR"
                                                            className="input-form"
                                                            selected={formGerais.dataInicio}
                                                            onChange={handleStartDateChange}
                                                            name={'dataInicio'}
                                                            placeholderText={'Data Inicial'}
                                                        />
                                                    </div>
                                                    <div className="position-relative form-group col-sm-12 col-md-6 col-lg-6 pl-0" style={{ float: 'left' }}>
                                                        <DatePicker
                                                            dateFormat="dd/MM/yyyy"
                                                            locale="pt-BR"
                                                            className="input-form"
                                                            selected={formGerais.dataFim}
                                                            onChange={handleEndDateChange}
                                                            name={'dataFim'}
                                                            placeholderText={'Data Final'}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                            <div>
                                                <div className='row justify-align-content-around mt-3'>
                                                    <div className="position-relative form-group col-sm-12 col-md-12 col-lg-12">
                                                        <Multiselect
                                                            className="searchWrapperCiclo"
                                                            placeholder={'Selecione o Ciclo(s) de Pagamento(s)'}
                                                            showCheckbox="true"
                                                            options={ciclosList} // Options to display in the dropdown
                                                            selectedValues={selectedCiclos}
                                                            onSelect={onGetCiclos} // Function will trigger on select event
                                                            onRemove={onRemoveCiclos}
                                                            displayValue='label' // Property name to display in the dropdown options
                                                            showArrow={true}
                                                        />
                                                    </div>
                                                </div>
                                            </div> 
                                            <div>
                                                <div className='row justify-align-content-around mt-3'>
                                                    <div className="col-sm-12 col-md-4 col-lg-4 col-xxl-4">
                                                    <DynamicSelectPME
                                                        placeholder=""
                                                        valuetext={formGerais.idEmpresa}
                                                        label="Selecione a empresa"
                                                        name="idEmpresa"
                                                        options={empresaList}
                                                        keyValue="idEmpresa"
                                                        keyLabel="description"
                                                        paramMethod={getEmpresa}
                                                        clearOption={true}
                                                    />

                                                    </div>
                                                    <div className="col-sm-12 col-md-8 col-lg-8 col-xxl-8">
                                                        <div className='row justify-align-content-around'>
                                                            <div className="position-relative form-group col-sm-8 col-md-8 col-lg-8">
                                                                <MemorizedDynamicInputAnexo
                                                                    ref={anexoUrl}
                                                                    placeholder={''}
                                                                    label={'URL Anexo'}
                                                                    name={'AnexoPath'}
                                                                    paramMethod={handleAnexoPathChange} 
                                                                    value={formGerais.anexoPath}
                                                                />
                                                            </div>
                                                            { isEdit ? 
                                                            <div className="position-relative form-group col-sm-4 col-md-4 col-lg-4">
                                                                <Flex>
                                                                    <Flex.Item className="flex-column-right-100">
                                                                        <Link title="Anexo" target="_blank" className="menu-link" to={{ pathname: formGerais.anexoPath }}>
                                                                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-box-arrow-up-right" viewBox="0 0 16 16">
                                                                                <path fillRule="evenodd" d="M8.636 3.5a.5.5 0 0 0-.5-.5H1.5A1.5 1.5 0 0 0 0 4.5v10A1.5 1.5 0 0 0 1.5 16h10a1.5 1.5 0 0 0 1.5-1.5V7.864a.5.5 0 0 0-1 0V14.5a.5.5 0 0 1-.5.5h-10a.5.5 0 0 1-.5-.5v-10a.5.5 0 0 1 .5-.5h6.636a.5.5 0 0 0 .5-.5" />
                                                                                <path fillRule="evenodd" d="M16 .5a.5.5 0 0 0-.5-.5h-5a.5.5 0 0 0 0 1h3.793L6.146 9.146a.5.5 0 1 0 .708.708L15 1.707V5.5a.5.5 0 0 0 1 0z" />
                                                                            </svg>
                                                                        </Link>
                                                                    </Flex.Item>
                                                                </Flex>
                                                            </div>
                                                            : ''}
                                                        </div>
                                                    </div>
                                                </div>
                                                
                                            </div>                                           
                                        </StyledForm>                                        
                                    </div>
                                    <div className="col-sm-12 col-md-2 col-lg-2 mt-1 ps-0">
                                        <input type="button" className='default-button-red-block btn-block ' value='Adicionar Novo Ciclo' onClick={openModalCicloPmeOpen} />
                                    </div>
                                </TabPanel>
                                {/* PERFIL */}
                                <TabPanel>
                                <div className="card">
                                        <div className='row justify-align-content-around mt-3'>
                                            <div className="position-relative form-group col-sm-12 col-md-4 col-lg-4">
                                                <div className="title-row">
                                                    <h5 className="title-row-header">Definições dos Multiplicadores </h5>
                                                </div>
                                            </div>
                                        </div>                               
                                    {perfisList.map((perf) => {
                                        return (
                                        <div className="card pb-1" key={ perf.id }>
                                            <div className="w-100 d-flex justify-content-between align-items-center">
                                                <div className="col-sm-12 col-md-2 col-lg-2 ps-0">
                                                    <h5 className="title-row-header me-2">{ perf.label }</h5>                                                    
                                                </div>
                                                {                                                    
                                                    isEdit ? 
                                                    <div className="col-sm-12 col-md-2 col-lg-2 ps-0">
                                                        <button className="default-button-red-small btn-block" onClick={ (event) => openModalPerfilTabelaPmeOpen(perf.id, event) }>Editar Dados</button>
                                                    </div>
                                                    : ''
                                                }
                                                <div className="col-sm-12 col-md-2 col-lg-2 ps-0">
                                                    <StyledUploadTimeSheet>
                                                        <input type="file" onChange={(event) => handleChangeUpdateTablePerfil(perf.id, event)} ref={(el) => (inputFileRefs.current[perf.id] = el)} accept=".xlsx, .xls, .csv, .xlsm" className="file_hide" />
                                                        <button className="default-button-red-small btn-block" onClick={() => inputFileRefs.current[perf.id]?.click()} >Importar Tabela</button>                                                        
                                                        {/* onChange={() => handleChangeUpdateTablePerfil(InputEvent)} { getacoesPerfis(0) }*/}
                                                    </StyledUploadTimeSheet>
                                                </div>
                                                <div className="col-sm-12 col-md-2 col-lg-4 ps-0">
                                                    {
                                                        //{uploadedFileNames[perf.id]}
                                                        uploadedFileNames[perf.id] && (
                                                        <span className="" style={{fontSize: "12px", fontWeight: "normal", color: "#666"}}>Tabela importada{ isEdit ? ", não esqueça de Atualizar Programa para não perder as informações" : "" }</span>
                                                    )}
                                                </div>
                                                <div className="col-sm-12 col-md-2 col-lg-4 ps-0"></div>
                                            </div>
                                        </div>
                                    )})}
                                </div>
                                <div className="col-sm-12 col-md-2 col-lg-2 mt-1 ps-0">
                                    <input type="button" className='default-button-red-block btn-block ' value='Adicionar Novo Perfil' onClick={openModalPerfilPmeOpen}/>
                                </div>
                                </TabPanel>
                                {/* GATILHOS */}
                                <TabPanel>
                                    <div className="card">
                                        <div className='row justify-align-content-around mt-3'>
                                            <div className="position-relative form-group col-sm-12 col-md-4 col-lg-4">
                                                <div className="title-row">
                                                    <h5 className="title-row-header">Definições de Gatilhos </h5>
                                                </div>
                                            </div>
                                        </div>
                                        <div className='row justify-align-content-around mt-3'>
                                            <div className="position-relative form-group col-sm-12 col-md-4 col-lg-4">
                                                <MemorizedDynamicInputHoraMediaFaturadaGlobal
                                                    mask="9999.99"
                                                    ref={horaMediaFaturadaGlobalRef}
                                                    placeholder={''}
                                                    label={'Hora Média Faturada Global (HMFg) *'}
                                                    name={'horaMediaFaturadaGlobal'}
                                                    paramMethod={handleHoraMediaFaturadaGlobalChange} 
                                                    value={formGatilhos.horaMediaFaturadaGlobal}
                                                />
                                            </div>
                                        </div>
                                        <div className='row justify-align-content-around mt-3'>
                                            <div className="position-relative form-group col-sm-12 col-md-4 col-lg-4">
                                                <MemorizedDynamicInputHoraMediaFaturadaUnidadeNegocio
                                                    mask="9999.99"
                                                    ref={horaMediaFaturadaUnidadeNegocioRef}
                                                    placeholder={''}
                                                    label={'Hora Média Faturada Unidades de Negócio (HMFu) *'}
                                                    name={'horaMediaFaturadaUnidadeNegocio'}
                                                    paramMethod={handleHoraMediaFaturadaUnidadeNegocioChange} 
                                                    value={formGatilhos.horaMediaFaturadaUnidadeNegocio}
                                                />
                                            </div>
                                        </div>
                                        <div className='row justify-align-content-around mt-3'>
                                            <div className="position-relative form-group col-sm-12 col-md-4 col-lg-4">
                                                <MemorizedDynamicInputHoraFaturadaIndividual
                                                    mask="9999.99"
                                                    ref={horaFaturadaIndividualRef}
                                                    placeholder={''}
                                                    label={'Hora Faturada Individual (HFi)*'}
                                                    name={'horaFaturadaIndividual'}
                                                    paramMethod={handleHoraFaturadaIndividualChange} 
                                                    value={formGatilhos.horaFaturadaIndividual}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </TabPanel>
                                {/* METAS */}
                                <TabPanel>
                                    <div className="card">
                                        <div className='row justify-align-content-around mt-3'>
                                            <div className="position-relative form-group col-sm-12 col-md-4 col-lg-4">
                                                <div className="title-row">
                                                    <h5 className="title-row-header">Meta </h5>
                                                </div>
                                                <div>Horas faturadas no periodo vigente. </div>
                                            </div>
                                            {/* <div className="position-relative form-group col-sm-12 col-md-8 col-lg-8">
                                                <DynamicSelectPME
                                                    placeholder={''}
                                                    valuetext={perfil}
                                                    label={'Categoria Profissional'}
                                                    name={'id'}
                                                    options={perfisList}
                                                    keyValue={'id'}
                                                    keyLabel={'label'}
                                                    paramMethod={getCategoriaProfissional} 
                                                    clearOption={true} />
                                            </div> */}
                                        </div>
                                        <div className='row justify-align-content-around mt-3'>
                                            <div className="position-relative form-group col-sm-12 col-md-4 col-lg-4">
                                                <MemorizedDynamicInputHMFGlobal
                                                    ref={HMFGlobalRef}
                                                    placeholder={''} 
                                                    label={'Meta HMF Global'} 
                                                    name={'HMFGlobal'} 
                                                    paramMethod={handleHMFGlobalChange} 
                                                    value={formMetas.HMFGlobal} />
                                            </div>
                                            <div className="position-relative form-group col-sm-12 col-md-4 col-lg-4">
                                                <MemorizedDynamicInputHMFUnidadeNegocio
                                                    ref={HMFUnidadeNegocioRef}
                                                    placeholder={''} 
                                                    label={'Meta HMF Un. de Negócios'} 
                                                    name={'HMFUnidadeNegocio'} 
                                                    paramMethod={handleHMFUnidadeNegocioChange} 
                                                    value={formMetas.HMFUnidadeNegocio} />
                                            </div>
                                            <div className="position-relative form-group col-sm-12 col-md-4 col-lg-4">
                                                <MemorizedDynamicInputHMFIndividual
                                                    ref={HMFIndividualRef}
                                                    placeholder={''} 
                                                    label={'Meta HMF Individual'} 
                                                    name={'HMFIndividual'} 
                                                    paramMethod={handleHMFIndividualChange} 
                                                    value={formMetas.HMFIndividual} />
                                            </div>
                                        </div>
                                        <div className='row justify-align-content-around mt-3'>
                                            <div className="position-relative form-group col-sm-12 col-md-4 col-lg-4">
                                                <MemorizedDynamicInputSuperHMFGlobal
                                                    ref={superHMFGlobalRef}
                                                    placeholder={''} 
                                                    label={'Super Meta HMF Global'} 
                                                    name={'superHMFGlobal'} 
                                                    paramMethod={handleSuperHMFGlobalChange} 
                                                    value={formMetas.superHMFGlobal} />
                                            </div>
                                            <div className="position-relative form-group col-sm-12 col-md-4 col-lg-4">
                                                <MemorizedDynamicInputSuperHMFUnidadeNegocio
                                                    ref={superHMFUnidadeNegocioRef}
                                                    placeholder={''} 
                                                    label={'Super Meta HMF Un. de Negócios'} 
                                                    name={'superHMFUnidadeNegocio'} 
                                                    paramMethod={handleSuperHMFUnidadeNegocioChange} 
                                                    value={formMetas.superHMFUnidadeNegocio} />
                                            </div>
                                            <div className="position-relative form-group col-sm-12 col-md-4 col-lg-4">
                                                <MemorizedDynamicInputSuperHMFIndividual
                                                    ref={superHMFIndividualRef}
                                                    placeholder={''} 
                                                    label={'Super Meta HMF Individual'} 
                                                    name={'superHMFIndividual'} 
                                                    paramMethod={handleSuperHMFIndividualChange} 
                                                    value={formMetas.superHMFIndividual} />
                                            </div>
                                        </div>                                        
                                    </div>                                        
                                    <div className="card">
                                        <div className='row justify-align-content-around mt-3'>
                                            <div className="position-relative form-group col-sm-12 col-md-4 col-lg-4">
                                                <div className="title-row">
                                                    <h5 className="title-row-header">Meta </h5>
                                                </div>
                                                <div>Critério: Horas faturadas no periodo vigente. </div>
                                            </div>
                                        </div>
                                        <div className='row justify-align-content-around mt-3'>
                                            <div className="position-relative form-group col-sm-12 col-md-4 col-lg-4">
                                                <MemorizedDynamicInputAdmRHD
                                                    ref={admRHDRef}
                                                    placeholder={''} 
                                                    label={'Meta de % RHD'} 
                                                    name={'admRHD'} 
                                                    paramMethod={handleAdmRHDChange} 
                                                    value={formMetas.admRHD} />
                                            </div>
                                            <code>⚠️ Somente para Administrativo Financeiro</code>
                                        </div>
                                    </div>
                                    {/* <div className='row justify-align-content-around mt-1'>
                                        <div className="col-sm-2 col-md-2 col-lg-2">
                                            <button type="button" className='default-button-red-block btn-block' onClick={() => { }}>  <i className="fa fa-plus" aria-hidden="true"></i> Inserir Meta</button>
                                        </div>
                                    </div> */}
                                </TabPanel>
                                {/* REGRAS */}
                                <TabPanel>
                                    <div className="card">
                                        <div className='row justify-align-content-around mt-3'>
                                            <div className="position-relative form-group col-sm-12 col-md-12 col-lg-12">
                                                <div className="title-row">
                                                    <h5 className="title-row-header"> Valores de regra e fatores de calibração</h5>
                                                </div>
                                            </div>
                                        </div>
                                        <div className='row justify-align-content-around mt-3'>
                                            <div className="position-relative form-group col-sm-4 col-md-4 col-lg-4">
                                                <div className="bold">% Franquia</div>
                                                <div style={{fontSize: "12px"}}>Tempo de Adaptação do Profissional</div>
                                            </div>
                                            <div className="position-relative form-group col-sm-2 col-md-2 col-lg-2">
                                                <ToggleSwitch 
                                                    ref={aplicarPercFranquiaRef}
                                                    config={{ name: 'aplicarPercFranquia', label: '', status: formRegras.aplicarPercFranquia }}
                                                    setStatus={handleToggleChangeAplicarPercFranquia} 
                                                    inicialStatus={formRegras.aplicarPercFranquia} />
                                            </div>
                                        </div>
                                        <div className='row justify-align-content-around mt-3'>
                                            <div className="position-relative form-group col-sm-3 col-md-3 col-lg-3">
                                                <MemorizedDynamicInputPercFranquia1Mes
                                                    mask="9999.99"
                                                    ref={percFranquia1MesRef}
                                                    placeholder={''} 
                                                    label={'% 1º mês de trabalho'} 
                                                    name={'percFranquia1Mes'} 
                                                    paramMethod={handlePercFranquia1MesChange} 
                                                    value={formRegras.percFranquia1Mes} />
                                            </div>
                                            <div className="position-relative form-group col-sm-3 col-md-3 col-lg-3">
                                                <MemorizedDynamicInputPercFranquia2Mes3Mes
                                                    mask="9999.99"
                                                    ref={percFranquia2Mes3MesRef}
                                                    placeholder={''} 
                                                    label={'% 2 meses seguintes'} 
                                                    name={'percFranquia2Mes3Mes'} 
                                                    paramMethod={handlePercFranquia2Mes3MesChange} 
                                                    value={formRegras.percFranquia2Mes3Mes} />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="card">   
                                        {isEdit ? (
                                        <>
                                             <div className="row justify-align-content-around mt-1">
                                                <div className="position-relative form-group col-sm-3 col-md-3 col-lg-3">
                                                    <MemorizedDynamicInputGatilhoMerito
                                                        mask="9999.99"
                                                        ref={gatilhoMeritoRef}
                                                        placeholder={''} 
                                                        label={'Gatilho Mérito'} 
                                                        name={'gatilhoMerito'} 
                                                        paramMethod={handleGatilhoMeritoChange} 
                                                        value={formRegras.gatilhoMerito} />
                                                </div>
                                            </div>

                                            <div className="col-sm-12 col-md-2 col-lg-2 mt-1 ps-0">
                                                <input
                                                    type="button"
                                                    className="default-button-red-block btn-block"
                                                    value="Nova Regra do Mérito"
                                                    onClick={() => openModalRegrasMeritoPme(-1)}
                                                />
                                            </div>

                                            <div className="row justify-align-content-around mt-1">
                                                {listMeritos && listMeritos.length > 0 && (
                                                    <div className="col-12 mt-3">
                                                        <div className="title-row">
                                                            <h5 className="title-row-header">Regras de Mérito Cadastradas</h5>
                                                        </div>
                                                        <table className="table table-bordered table-width table-sm">
                                                            <thead>
                                                                <tr>
                                                                    <th>Ações</th>
                                                                    <th>Área</th>
                                                                    <th>HFMI</th>
                                                                    <th>HMFU</th>
                                                                    <th>HMFG</th>                                                                    
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {listMeritos.sort((a, b) => a.idArea - b.idArea).map((item, index) => (
                                                                    <tr key={index}>
                                                                        <td>
                                                                            <span className="cursor-pointer color-icon-default m-1" onClick={() => openModalRegrasMeritoPme(item.idRegrasMerito)} title="Editar Projeto Interno"><i className="fa fa-edit" aria-hidden="true"></i></span>
                                                                            <span className="cursor-pointer color-icon-default m-1" onClick={() => inativarRegraMerito(item.idRegrasMerito)} title="Inativar"><i className="fa fa-ban"></i></span>
                                                                        </td>
                                                                        <td>
                                                                            {
                                                                                item.nomeArea
                                                                                .split(",")
                                                                                .map(area => area.trim())
                                                                                .filter(area => !areasExcluidas.includes(area))
                                                                                .map((area, index) => (
                                                                                    <span key={index} className={'badge bg-lightblue me-1'}>{area}</span>
                                                                                ))
                                                                            }
                                                                        </td>
                                                                        <td>{item.valorHFMI}</td>
                                                                        <td>{item.valorHMFU}</td>
                                                                        <td>{item.valorHMFG}</td>                                                                        
                                                                    </tr>
                                                                ))}
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                )}
                                            </div>
                                        </>
                                    ) : null}
                                      
                                    </div>
                                </TabPanel>
                                {/* PROFISSIONAIS */}
                                <TabPanel>
                                <div className="card">
                                    { isEdit ?
                                        <div className="row justify-content-end my-2 text-right">
                                            <div className="col">
                                                <input type="button" className='default-button-red-block btn-block ' value='Adicionar Profissional' onClick={openModalProfissionalPmeOpen}/>
                                            </div>
                                            <div className="col-4"></div>                                            
                                            <div className="col">
                                                <label>
                                                    <span className="text-max-10 mx-2">Total Participantes</span>
                                                    <span className="badge bg-primary">{ usuariosFiltrados?.length } </span>
                                                </label>
                                            </div>
                                            <div className="col">
                                                <label>
                                                    <span className="text-max-10 mx-2">Gatilho</span>
                                                    <span className="badge bg-primary">{ formGatilhos.horaFaturadaIndividual.toLocaleString('pt-BR', { minimumFractionDigits: 0, maximumFractionDigits: 1 }) } </span>
                                                </label>
                                            </div>
                                            <div className="col">
                                                <label>
                                                    <span className="text-max-10 mx-2">Meta</span>
                                                    <span className="badge bg-primary">{ formMetas.HMFIndividual.toLocaleString('pt-BR', { minimumFractionDigits: 0, maximumFractionDigits: 1 }) } </span>
                                                </label>
                                            </div>
                                            <div className="col">
                                                <label>
                                                    <span className="text-max-10 mx-2">Super Meta</span>
                                                    <span className="badge bg-primary">{ formMetas.superHMFIndividual.toLocaleString('pt-BR', { minimumFractionDigits: 0, maximumFractionDigits: 1 }) } </span>
                                                </label>
                                            </div>
                                        </div>
                                    : ''}
                                    <Flex>
                                        <StyledForm style={{ width: "100%" }}>                                        
                                            {isLoading ? 
                                                <StldRow>
                                                    <div className="text-center">
                                                        <div className="d-flex align-items-center">
                                                            <strong style={{ color: "#EE4B21" }}>Atualizando...</strong>
                                                            <div className="spinner-border ms-auto" style={{ color: "#EE4B21" }} role="status" aria-hidden="true"></div>
                                                        </div>
                                                    </div>
                                                </StldRow>
                                            :
                                                <StyledTablePmePrograma>
                                                    <StyledTablePage>
                                                        {
                                                            listaUsuariosData?.data?.length > 0 ? 
                                                            (
                                                                <div className="table-scroll font-0-9x table-bordered table-container">
                                                                    <table className="table table-width table-sm">
                                                                        <thead>
                                                                        { !isEdit ? (
                                                                            <tr className="table-legend-info">                                                                                
                                                                                <th>
                                                                                    <input
                                                                                        type="checkbox"
                                                                                        onChange={(e) => handleSelectAll(e.target.checked)}
                                                                                        checked={
                                                                                            selectedUsers.length === listaUsuariosData.data.length &&
                                                                                            selectedUsers.length > 0
                                                                                        }
                                                                                    />
                                                                                </th>                                                                                
                                                                                <th key="nomeUsuario">Profissional</th>
                                                                            </tr>
                                                                            ) : (
                                                                                <tr className="table-legend-info">
                                                                                    <th key="acoes">Ações</th>                                                                             
                                                                                    <th key="nomeUsuario">Profissional
                                                                                        <input
                                                                                            type="text"
                                                                                            placeholder="..."
                                                                                            value={filtroNome}
                                                                                            onChange={(e) => setFiltroNome(e.target.value)}
                                                                                            style={{ width: "100%", marginTop: "5px", height: "30px" }}
                                                                                        />
                                                                                    </th>
                                                                                    <th key="idDisciplina">Área
                                                                                        <input
                                                                                            type="text"
                                                                                            placeholder="..."
                                                                                            value={filtroArea}
                                                                                            onChange={(e) => setFiltroArea(e.target.value)}
                                                                                            style={{ width: "100%", marginTop: "5px", height: "30px" }}
                                                                                        />
                                                                                    </th>
                                                                                    <th key="dataAdmissao">Data Admissão</th>
                                                                                    <th key="dataSaida">Data Saída</th>
                                                                                    <th key="percProfissional">% Profissional</th>
                                                                                    <th key="participacaoCalibracaoTempo">Part. Calib.<br /> Tempo</th>
                                                                                    <th key="percProfissionalFranquia">Part. Calib.<br /> Franquia e Prof</th>                                                                                    
                                                                                    <th key="percProfissionalCalibTempo">% Calib.<br /> Tempo</th>
                                                                                    <th key="percProfissionalCalibFrqanquiaProf">% Calib. <br />Franquia e Prof. </th>
                                                                                    <th key="percProfissionalCalibTotal">% Calib. Total</th>
                                                                                    {/* <th key="partCalculo">Part. Cálculo</th> 
                                                                                    <th key="status">Status</th>*/}
                                                                                </tr>
                                                                            )
                                                                        }
                                                                        </thead>
                                                                        <tbody>
                                                                            {
                                                                            usuariosFiltrados
                                                                            ?.sort((a, b) => a.nome.localeCompare(b.nome))
                                                                            .map((usuario, index) => (                                                                                
                                                                                !isEdit ? (
                                                                                    <tr key={index}>
                                                                                        <td className="text-center">
                                                                                            <input
                                                                                                type="checkbox"
                                                                                                checked={selectedUsers.includes(usuario.idUsuario)}
                                                                                                onChange={() => handleCheckboxUsuariosChange(usuario.idUsuario)}
                                                                                            />
                                                                                        </td>
                                                                                        <td className="text-center">{usuario?.nome}</td>
                                                                                    </tr>
                                                                                ) : (                                                                                 
                                                                                    <tr key={`row-profissional-${usuario.idProfissional}`}>
                                                                                        <td className="d-flex justify-content-center border-left-0 border-bottom-0 border-right-0">{ getacoes(usuario.idProfissional) }</td>
                                                                                        <td className="text-center">{ usuario.nome }</td>
                                                                                        <td className="text-center">{ usuario.nomeArea }</td>
                                                                                        <td className="text-center">{ new Intl.DateTimeFormat('pt-BR').format(new Date(usuario.dataAdmissao)) }</td>
                                                                                        <td className="text-center">{ usuario.dataDemissao == null ? '-' : new Intl.DateTimeFormat('pt-BR').format(new Date(usuario.dataDemissao)) }</td>
                                                                                        <td className="text-center">
                                                                                            <MemorizedDynamicInput 
                                                                                                placeholder={''} 
                                                                                                label={''}
                                                                                                className={'text-center'}
                                                                                                style={{width: "60px"}}
                                                                                                name={`percProfissional-${usuario.idProfissional}`} 
                                                                                                paramMethod={(newValue) => handlePercProfissionalChange(usuario.idProfissional, 'percProfissional', newValue)}
                                                                                                onChange={(newValue) => handleChangeCalibTotal(usuario.idProfissional, usuario.dataAdmissao, usuario.dataDemissao, newValue)}
                                                                                                value={usuario?.percProfissional || 0} />
                                                                                        </td>
                                                                                        <td className="text-center">
                                                                                            <div className="w-100 d-flex justify-content-center toggleporc">
                                                                                            <ToggleSwitch 
                                                                                                config={{ name: `participacaoCalibracaoTempo-${usuario.idProfissional}`, label: '', status: usuario.participacaoCalibracaoTempo }}
                                                                                                setStatus={(status) => handleToggleChangeParticipacaoCalibracaoTempo(usuario.idProfissional, status)}
                                                                                                inicialStatus={usuario.participacaoCalibracaoTempo} />
                                                                                            </div>
                                                                                        </td>
                                                                                        <td className="text-center">
                                                                                            <div className="w-100 d-flex justify-content-center toggleporc">                                                                                                
                                                                                            <ToggleSwitch 
                                                                                                config={{ name: `participacaoFranquia-${usuario.idProfissional}`, label: '', status: usuario.participacaoFranquia }}
                                                                                                setStatus={(status) => handleToggleChangeParticipacaoFranquia(usuario.idProfissional, status)}
                                                                                                inicialStatus={usuario.participacaoFranquia} />
                                                                                            </div>
                                                                                        </td>                                                                                        
                                                                                        <td className="text-center">{ calcularPorcentagemTempoXAdmissao(usuario.idProfissional, usuario.dataAdmissao, usuario.dataDemissao).toLocaleString('pt-BR', { minimumFractionDigits: 5, maximumFractionDigits: 5 }) }</td>
                                                                                        <td className="text-center">{ calcularPorcentagemProfissionalFranquia(usuario.idProfissional, usuario.dataAdmissao, usuario.percProfissional).toLocaleString('pt-BR', { minimumFractionDigits: 5, maximumFractionDigits: 5 }) }</td>
                                                                                        <td className="text-center">{ calcularCalibracaoTotal(usuario.idProfissional, usuario.dataAdmissao, usuario.dataDemissao, usuario.percProfissional).toLocaleString('pt-BR', { minimumFractionDigits: 5, maximumFractionDigits: 5 }) }</td>                                                                                  
                                                                                    </tr>
                                                                                )
                                                                            ))}
                                                                        </tbody>
                                                                    </table>
                                                                </div>
                                                            ) : listaUsuariosData?.data && listaUsuariosData.data?.length === 0 ? (
                                                                <StldColumn xs="12" sm="12" md="12">
                                                                    <div className="alert alert-warning" role="alert">
                                                                        Atenção! Nenhum resultado encontrado!
                                                                    </div>
                                                                </StldColumn>
                                                            ) : (
                                                                <StldColumn xs="12" sm="12" md="12">
                                                                    <div className="alert alert-warning" role="alert">
                                                                        Erro ao carregar os dados ou estrutura inesperada.
                                                                    </div>
                                                                </StldColumn>
                                                            )
                                                        }
                                                    </StyledTablePage>
                                                </StyledTablePmePrograma>
                                            }
                                        </StyledForm>
                                    </Flex>
                                </div>
                                </TabPanel>
                            </div>
                        </Tabs>                        
                    </StyledProgramasFormPmePage>
                </StyledDefaultPage>

                <ModalCicloPme
                    isOpen={modalCicloPme}
                    onAfterOpen={afterModalCicloPmeOpen}
                    onRequestClose={closeModalCicloPme}
                    loadPage={isLoading}
                    tiposCiclosList={ciclosTiposList}
                    onUpdateCiclos={handleUpdateCiclos}
                >
                </ModalCicloPme>

                <ModalPerfilPme
                    isOpen={modalPerfilPme}
                    onAfterOpen={afterModalPerfilPmeOpen}
                    onRequestClose={closeModalPerfilPme}
                    loadPage={isLoading}
                    perfisList={perfisList}
                    onUpdatePerfis={handleUpdatePerfis}
                >
                </ModalPerfilPme>

                <ModalImportPMEMultiplicadores
                    isOpen={modalPerfilTabelaPme}
                    modalData={modalPerfilTabela}
                    onAfterOpen={afterModalPerfilTabelaPmeOpen}
                    onRequestClose={closeModalPerfilTabelaPme}
                    loadPage={isLoading}
                >
                </ModalImportPMEMultiplicadores>

                <ModalRegrasMeritoPme
                    isOpen={modalRegrasMeritoPme}
                    onAfterOpen={afterModalRegrasMeritoPme}
                    onRequestClose={closeModalRegrasMeritoPme}
                    listArea={areas}
                    listMeritos={listMeritos}
                    idProgramaParam={idProgramaParam}
                    meritoEdit={meritoEdit}
                    idRegraMerito={idRegraMerito}
                    loadPage={isLoading}
                >
                </ModalRegrasMeritoPme>                

                <ModalProfissionalPme
                    isOpen={modalProfisionalPme}
                    onAfterOpen={afterModalProfissionalPmeOpen}
                    onRequestClose={closeModalProfissionalPme}
                    idProgramaParam={idProgramaParam}
                >
                </ModalProfissionalPme>
            </main>
        </section>
    );
};

export const ProgramasFormPmePage = () => {
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    return (
        <>
            {isMenuOpen ? (
                <MenuPage
                    isMenuOpen={isMenuOpen}
                    setIsMenuOpen={setIsMenuOpen}
                />
            ) : (
                <>
                    <Header
                        isMenuOpen={isMenuOpen}
                        setIsMenuOpen={setIsMenuOpen}
                    />
                    <PmeProgramasForm />

                </>
            )}
        </>
    );
};
